$("#registered_litters").chosen();